import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import useTable from "../../../../MainComponents/Hooks/useTable";
import useAxios from "../../../../MainComponents/Hooks/useAxios";

const AdminViewExamLateStudent = () => {
  const { ID } = useParams();
  const [systemType, setSystemType] = useState(null);

  const [ExamInfo] = useAxios(
    `${process.env.REACT_APP_ADMIN_TRIAL_EXAM_INFO_API}/${ID}`,
    "GET",
    ID,
    ID,
  );

  const examStage = ExamInfo?.data?.stage;
  const examSystemType = ExamInfo?.data?.system_type || "all";
  const isThirdSec = +examStage === 3;

  useEffect(() => {
    if (ExamInfo?.data) {
      setSystemType(ExamInfo.data.system_type || "all");
    }
  }, [ExamInfo]);

  const tableParams = useMemo(() => {
    if (!ID) return "";
    if (isThirdSec && systemType) {
      return `${ID}?system_type=${systemType}`;
    }
    return ID;
  }, [ID, isThirdSec, systemType]);

  const table = useTable(
    "viewStudentLate",
    "",
    "",
    ID,
    `${systemType || "default"}`,
    tableParams,
  );

  return (
    <section className="dark:bg-dark dark:text-light flex h-full w-full flex-col items-start overflow-y-auto px-10 py-10 sm:px-4 md:items-center">
      <HelmetTags title="Late Students | Mr.Mohamed Salama" />
      <h2 className="text-start text-2xl font-bold">Late Students</h2>

      {isThirdSec && systemType && (
        <div className="filters-container mt-6 mb-4 flex w-full justify-center bg-slate-100 dark:bg-[#121a35]">
          <div className="filters relative flex h-12 w-[900px] items-center justify-between transition-all duration-200 ease-in-out md:w-full">
            <button
              type="button"
              onClick={() => setSystemType("all")}
              className={`flex h-full w-1/3 cursor-pointer items-center justify-center font-semibold ${
                systemType === "all" ? "bg-green" : ""
              }`}
            >
              الكل
            </button>
            <button
              type="button"
              onClick={() => setSystemType("hand_by_hand")}
              className={`flex h-full w-1/3 cursor-pointer items-center justify-center font-semibold ${
                systemType === "hand_by_hand" ? "bg-green" : ""
              }`}
            >
              ايد بايد
            </button>
            <button
              type="button"
              onClick={() => setSystemType("normal")}
              className={`flex h-full w-1/3 cursor-pointer items-center justify-center font-semibold ${
                systemType === "normal" ? "bg-green" : ""
              }`}
            >
              النظام العادي
            </button>
          </div>
        </div>
      )}

      {isThirdSec && examSystemType && (
        <p className="mb-4 text-sm text-slate-500 dark:text-slate-300">
          نظام الامتحان الافتراضي:{" "}
          {examSystemType === "hand_by_hand"
            ? "ايد بايد"
            : examSystemType === "normal"
              ? "النظام العادي"
              : "الكل"}
        </p>
      )}

      <div className="h-fit w-full">
        {(!isThirdSec || systemType) && table}
      </div>
    </section>
  );
};

export default AdminViewExamLateStudent;
